import $ from 'jquery';
import 'bootstrap';

export default function initTooltip() {
  // bootstrap tooltip functionality
  $('[data-toggle="tooltip"]').tooltip();
}

$(document).ready(initTooltip);
